const SwitchToggle = ({onSwitch, label, state, onColor, offColor}) => {
  return ( 
    <div onClick={onSwitch} className="flex text-gray-600 border space-x-6 cursor-pointer col-span-2 rounded my-1 justify-between items-center px-8 py-1">
      <label className="text-sm cursor-pointer" htmlFor="switch">{label}</label>
      <div id="switch" className={`w-12 h-7 ${state ? onColor: offColor} rounded-full flex-shrink-0 p-1`}>      
        <div className={`bg-white w-5 h-5 rounded-full transform ${state && 'translate-x-5'} shadow-md`}></div>
      </div>
    </div>
  );
}
 
export default SwitchToggle;